import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './HangingDecorations.css';
import SwingBadge from './SwingBadge';

const HangingDecorations = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [scrollVisible, setScrollVisible] = useState(true);
  const [touchTimeout, setTouchTimeout] = useState(null);
  const location = useLocation();

  // Hide decorations on personal and blogs pages
  useEffect(() => {
    setIsVisible(location.pathname !== '/personal' && location.pathname !== '/blogs');
  }, [location.pathname]);

  // Hide decorations when scrolling down
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      // Hide when scrolled down more than 50px
      setScrollVisible(scrollY < 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (touchTimeout) {
        clearTimeout(touchTimeout);
      }
    };
  }, [touchTimeout]);

  // If not visible, don't render
  if (!isVisible || !scrollVisible) return null;

  const decorations = [
    { type: 'star', length: '200px', delay: '0s' },
    { type: 'circle', length: '180px', delay: '0.1s' },
    { type: 'star', length: '185px', delay: '0.2s' },
    { type: 'circle', length: '200px', delay: '0.15s' },
    { type: 'star', length: '150px', delay: '0.25s' },
    { type: 'circle', length: '160px', delay: '0.3s' },
    { type: 'star', length: '130px', delay: '0.35s' },
    { type: 'circle', length: '180px', delay: '0.4s' },
    { type: 'star', length: '190px', delay: '0.45s' },  
    { type: 'circle', length: '200px', delay: '0.5s' },   
    { type: 'star', length: '160px', delay: '0.55s' },                
    { type: 'circle', length: '170px', delay: '0.6s' },
  ];

  const handleTouchStart = () => {
    // Clear any existing timeout
    if (touchTimeout) {
      clearTimeout(touchTimeout);
    }
    setIsAnimating(true);
  };

  const handleTouchEnd = () => {
    // Set a timeout to stop animation after a delay
    const timeout = setTimeout(() => {
      setIsAnimating(false);
    }, 2000); // Stop after 2 seconds (same as animation duration)
    setTouchTimeout(timeout);
  };

  return (
    <>
    <div className="crescent-moon" />
    <SwingBadge />
    <div
      className="hanging-decorations"
      onMouseEnter={() => setIsAnimating(true)}
      onMouseLeave={() => setIsAnimating(false)}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      {decorations.map((dec, index) => (
        <div 
          key={index} 
          className={`string ${isAnimating ? 'swing' : ''}`}
          style={{ 
            '--string-length': dec.length,
            '--animation-delay': dec.delay 
          }}
        >
          <div className="string-line" />
          <div className={`decoration ${dec.type}`} />
        </div>
      ))}
    </div>
    </>
  );
};

export default HangingDecorations; 